import { createStore, applyMiddleware, compose } from "redux";

import thunk from "redux-thunk";
import promise from "redux-promise-middleware";
//import logger from "redux-logger";

import reducer_index from "./Reducers/index.js"

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//const middleware = applyMiddleware(promise(), thunk, logger);
const middleware = applyMiddleware(promise(), thunk);

const store = createStore(reducer_index, /* preloadedState, */ composeEnhancers(
    middleware
));

export default store;